<script>
  // @ts-check
  import Icon from "../../atoms/Icon.svelte";
  import Image from "../../atoms/Image.svelte";
  import Rule from "../../atoms/Rule.svelte";
  import { validatePropObjectWithSchema } from "../../utilities/logs";
  import { getTheme } from "../../utilities/themes";

  // An Object type Link with URL, and name
  /** @typedef {Object} Link
   * @property {string} url
   * @property {string} label
   * @property {string} imageSrc
   * @property {string} [srcset]
   * @property {string} [sizes]
   */

  /** @type {Link} */
  export let link;
  const linkSchema = {
    url: "string",
    label: "string",
    imageSrc: "string",
    srcset: "string",
    sizes: "string"
  };

  validatePropObjectWithSchema({
    componentName: "StaticMenuLink",
    propName: "link",
    propValue: link,
    schema: linkSchema
  });

  const colorTheme = getTheme("white");
</script>

<a
  href={link.url}
  class="group my-3 flex items-center transition group-first-of-type/li:mt-0 md:my-4 lg:my-5 xl:my-6 {colorTheme.textColor} {colorTheme.hoverTextColor} focus-visible:outline-dashed focus-visible:outline-offset-4 {colorTheme.focusOutlineColor} {colorTheme.focusTextColor}"
  data-sveltekit-reload
>
  <span class="heading-xs block lg:cta-lg xl:heading-xs">{link.label}</span>
  <div class="flex flex-1 items-center justify-between gap-4">
    <span
      class="pl-1 opacity-transparent
            group-hover:opacity-opaque
            group-focus:opacity-opaque
          "
    >
      <Icon name="arrowRight" />
    </span>
    {#if link.imageSrc}
      <Image
        id="static-menu-link-image"
        aspectRatioClasses="aspect-1/1"
        containerClass="lg:opacity-transparent w-10 h-10 xl:w-[3rem] xl:h-[3rem] justify-self-end
                      group-hover:opacity-opaque
                      group-focus:opacity-opaque
                      "
        src={link.imageSrc}
        srcset={link.srcset}
        sizes={link.sizes}
        alt=""
      />
    {/if}
  </div>
</a>
<Rule type="thin" theme="white" />
